"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideCoreDataSecurityApplicationsSlice = void 0;
const name_1 = require("./name.js");
const get_1 = require("./all/get.js");
const get_2 = require("../app-users/get.js");
const data_security_1 = require("../../../api/data-security/index.js");
const remove_1 = require("./remove.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.hideCoreDataSecurityApplicationsSlice = (0, xuder_1.createDeleteAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.APPLICATION_MODIFIED, (action) => action.data),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        preRequestActionCreators: [remove_1.removeCoreDataSecurityApplicationSyncSlice.syncActionCreator],
        successActionCreators: [
            get_2.getCoreDataSecurityAppUsersSlice.asyncActionCreators.repeatGetCoreDataSecurityAppUsers,
            get_1.getCoreDataSecurityApplicationsAllSlice.asyncActionCreators.repeatGetCoreDataSecurityApplicationsAll
        ]
    },
    name: name_1.CoreDataSecurityApplicationsName,
    receive: false,
    request: true,
    requestHandler: data_security_1.hideDataSecurityApplicationById
});
//# sourceMappingURL=hide.js.map